import { IAmendmentPagedRequest } from '../../../../model/sge/amendment/request/amendment-paged-request';
import { IParlamentarianPagedResponse } from '../../../../model/sge/parlamentarian/response/parlamentarian-paged-response';
import { IPoliticalPartyPagedResponse } from '../../../../model/sge/political-party/response/political-party-paged-response';
import { IBudgetUnitResponse } from '../../../../model/sge/budget-unit/response/budget-unit-response';
import { IBudgetProgramResponse } from '../../../../model/sge/budget-program/response/budget-program-response';
import { IBudgetActionResponse } from '../../../../model/sge/budget-action/response/budget-action-response';

export type AmendmentSearchState = {
    parameters: IAmendmentPagedRequest;
    parlamentarians: IParlamentarianPagedResponse[];
    politicalParties: IPoliticalPartyPagedResponse[];
    budgetUnits: IBudgetUnitResponse[];
    budgetPrograms: IBudgetProgramResponse[];
    budgetActions: IBudgetActionResponse[];
    searchTrigger: number;
};

export enum ACTION_TYPES {
    updateParameter = 'updateParameter',
    setParlamentarians = 'setParlamentarians',
    setPoliticalParties = 'setPoliticalParties',
    setBudgetUnits = 'setBudgetUnits',
    setBudgetPrograms = 'setBudgetPrograms',
    setBudgetActions = 'setBudgetActions',
    triggerSearch = 'triggerSearch',
}

export const AmendmentSearchReducer = (state: AmendmentSearchState, action: any): AmendmentSearchState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.updateParameter:
            return { ...state, parameters: { ...state.parameters, ...payload } };
        case ACTION_TYPES.setParlamentarians:
            return { ...state, parlamentarians: payload };
        case ACTION_TYPES.setPoliticalParties:
            return { ...state, politicalParties: payload };
        case ACTION_TYPES.setBudgetUnits:
            return { ...state, budgetUnits: payload };
        case ACTION_TYPES.setBudgetPrograms:
            return { ...state, budgetPrograms: payload };
        case ACTION_TYPES.setBudgetActions:
            return { ...state, budgetActions: payload };
        case ACTION_TYPES.triggerSearch:
            return { ...state, searchTrigger: state.searchTrigger + 1 };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
